export function scrollTo(target, options = {}) {
	options = Object.assign({
		context: "[role=\"main\"]",
		shift: 0,
		smooth: false,
		whenAboveView: false,
	}, options);

	let contextElement = document.querySelector(options.context);
	if (!contextElement) {
		return;
	}

	let scrollOptions = {
		behavior: options.smooth ? "smooth" : "auto",
	};

	if (Number.isInteger(target)) {
		scrollOptions.top = target + options.shift;
		return contextElement.scrollTo(scrollOptions);
	}

	let targetElement = contextElement.querySelector(target);
	if (!targetElement) {
		return;
	}

	target = targetElement.offsetTop - contextElement.offsetTop;
	let currentOffset = targetElement.getBoundingClientRect().top - contextElement.offsetTop;
	let aboveView = currentOffset < 0;

	if (!aboveView && options.whenAboveView) {
		return;
	}

	scrollOptions.top = target - options.shift;
	contextElement.scrollTo(scrollOptions);
}
